import React from "react";

const images = require.context("../../../assets/images/", true);

const Logo = (props) => {
  if (props.style === "white") {
    return <img alt="aptihealth logo" className="img-fluid" src={images("./common/logo.svg")} />;
  }

  return (
    <img
      alt="aptihealth logo"
      className="img-fluid"
      src={images("./common/apti_logo_white.png")}
      style={{ maxHeight: "31px", maxWidth: "200px" }}
    />
  );
};

export default Logo;
